var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLitecoin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12ZM13.132 4.58157L11.7223 4.06896C11.4628 3.97459 11.1759 4.10847 11.0816 4.36798L8.97497 10.1611L5.87223 10.5748C5.59851 10.6113 5.4062 10.8628 5.4427 11.1365L5.57486 12.1278C5.61136 12.4015 5.86284 12.5938 6.13656 12.5573L8.20387 12.2817L6.82527 16.0728C6.68591 16.456 6.74224 16.8831 6.97617 17.2171C7.21011 17.5511 7.59224 17.75 8.00001 17.75H16.75C17.0261 17.75 17.25 17.5261 17.25 17.25V15.75C17.25 15.4739 17.0261 15.25 16.75 15.25H9.78463L10.9996 11.9089L14.6278 11.4251C14.9015 11.3886 15.0938 11.1372 15.0573 10.8634L14.9252 9.87222C14.8887 9.5985 14.6372 9.40619 14.3635 9.44268L11.7707 9.78839L13.4311 5.22234C13.5254 4.96282 13.3915 4.67594 13.132 4.58157Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLitecoin);
export default __webpack_public_path__ + "static/media/litecoin.8e82bbc47405b3f110c1bb9dfbb61fd8.svg";
export { ForwardRef as ReactComponent };